import { TextProps } from '@chakra-ui/react';

export const TextMaxCards: TextProps = {
  fontSize: 'sm',
  fontWeight: 'semibold',
  lineHeight: '14.4px',
  color: 'brand.500',
};
